import { NavbarGroup, navbarGroupIdAdmin, NavbarHeader, NavbarItem } from '@safarilaw-webapp/shared/app-bootstrap/data-access';

export const environmentImports: NavbarItem[] | NavbarGroup[] | NavbarHeader[] = [
  new NavbarHeader(99000, navbarGroupIdAdmin, 'Dev Tools', 's_mnu-link-dev', []),

  new NavbarItem(99015, 99000, 'Safari Components', '/dev-tools/safari-components'),
  new NavbarItem(99016, 99000, 'Safari Demos', '/dev-tools/safari-demos'),
  new NavbarItem(99017, 99000, 'Safari Utilities', '/dev-tools/safari-utilities')
];
